/*
 * Fixed above the performance page navigation, which takes the bottom 56px on phones.
 * The content pane reserves room for both (see .contentPane--tiny).
 */
.bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: calc(56px + env(safe-area-inset-bottom, 0px));
  z-index: 2;
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-0_5) var(--tuna-spacing-1);
  background-color: var(--tuna-palette-background-paper);
  border-top: 1px solid var(--tuna-palette-divider);
}

.spacer {
  flex: 1 1 auto;
}

/* Stage-sized touch targets: at least 48px */
.target,
.bar :global(button) {
  min-height: var(--tuna-spacing-6);
  min-width: var(--tuna-spacing-6);
}

/* Sentence case, like the Perform header ("+ Jot", "My notes") */
.bar :global(button) {
  text-transform: none;
}
